import { atom } from 'nanostores';

export const appContainerFadedOutStore = atom<boolean>(false);
export function setAppContainerFadedOut(fadedOut: boolean) {
  appContainerFadedOutStore.set(fadedOut);
  return appContainerFadedOutStore.get();
}

export const appContainerOutletRenderedStore = atom<boolean>(true);
export function setAppContainerOutletRendered(rendered: boolean) {
  appContainerOutletRenderedStore.set(rendered);
  return appContainerOutletRenderedStore.get();
}
